import { Component, OnInit, Input } from '@angular/core';
import { TagSystem } from '../masterdata/models/tag-system';
import { LabMDM } from '../masterdata/models/lab';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { SelectableLab } from '../carrier/selectable-lab';
import { APGTestingService } from '../agptesting-newview/apgtesting.service';


@Component({
  selector: 'app-mdm-tag-system',
  templateUrl: './mdm-tag-system.component.html',
  styleUrls: ['./mdm-tag-system.component.css']
})
export class MdmTagSystemComponent implements OnInit {

  @Input() masterLists: TagSystem[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() tagSystems: string[];
  @Input() loading:boolean;
  
  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  selectedMasterList: TagSystem;
  popupTitle: string;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  isNewMasterList: boolean;
  masterList: TagSystem;
  selectedLabName: string;
  selectedLab: LabMDM;
  uploadedFile: any;
  disableDownloadTagsButton:boolean= true;
  disableDownloadPlateButton:boolean= true;
  uploadedFileName: string;
  blocked: boolean = false;

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService, private apgTestingService: APGTestingService) { }

  ngOnInit() {
    this.getActiveOptionsForDropdowns();
  }

   //Display Add Dialog upon clicking Add button
   showDialogToAddMasterList() {

    this.isNewMasterList = true;
    this.masterList = new TagSystem;
    this.uploadedFile = null;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.uploadedFileName="";
  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.uploadedFileName = this.masterList.tagExcelFileName;
    this.uploadedFile = null;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
  }
  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      resultLabs => {
        if (!resultLabs) {
          return;
        }  
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = resultLabs.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

  }

  isSaveDisabled() {
    return !(this.masterList && this.masterList.tagSystemName && this.selectedLab);
  }
  private handleError(error: any) {
    this.blocked=false
    let message = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(message);
  }
  //Insert or update Template
  saveMasterList() { 
    let masterLists
    if(!this.masterLists){
      masterLists = []
    }else{
      masterLists = [...this.masterLists];
    }
    if (this.isNewMasterList) {
      this.blocked=true;
      this._masterDataService.checkExistance(this.selectedLab._id , this.masterList.tagSystemName).subscribe(
        results => {
          if (results) {
            if(!results.data){
              this.saveMasterData(masterLists);
            }else {
              this._messageService.addErrorMessage({
              severity: 'error', summary: 'Tag System Name not unique!!',
              detail: 'Tag System Name already exists.Tag(s) / Tag Plate(s) not created'
              });
            }
          }
          this.blocked=false
        },
        error => {
          this.handleError(error);
          }
      );
    } else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterLists = this.masterLists ? this.masterLists : []
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.appendHistory("Tag System");
    if(this.uploadedFile){
      const formDataSave = new FormData();
      formDataSave.append('file', this.uploadedFile);
      formDataSave.append('fileName', this.uploadedFile.name);
      formDataSave.append('labId', this.selectedLab._id.toString());
      formDataSave.append('excelUploadCreatedAt', new Date().toString());
      formDataSave.append('excelUploadCreatedBy', this.puid);
      formDataSave.append('tagSystemName', this.masterList.tagSystemName);

      this.masterList.tagExcelFileName = this.uploadedFile.name;
      this.apgTestingService.saveTagsExcel(formDataSave).subscribe(
        resultSaveTag => {
          if (!resultSaveTag) {
            return;
          }
          this.displayMasterListDialog = false;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Created Tags!', detail: 'Tags in the Excel File are Created.' });
          this.masterList.tagPlates = resultSaveTag.data;
          this._masterDataService.addTagSystem(this.masterList).subscribe(
            resultsTagSave => {
              if (!resultsTagSave) {
                return;
              }
              masterLists = [...this.masterLists];
              masterLists.push(resultsTagSave.data);
              this.masterLists = masterLists;
              this.masterList = null;
              this.displayMasterListDialog = false;
              this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Tag System!', detail: 'Tag System is created.' });
            },
            error => {
            let message = this.errorHandler.handleError(error);
            this._messageService.addErrorMessage(message);
              }
          );
        },
        error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
          }
      );
    } else{
      this._masterDataService.addTagSystem(this.masterList).subscribe(
        resultAddTag=> {
          if (!resultAddTag) {
            return;
          }
          masterLists = [...this.masterLists];
          masterLists.push(resultAddTag.data);
          this.masterLists = masterLists;
          this.displayMasterListDialog = false;
          this.masterList = null;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Tag System!', detail: 'Tag System is created.' });
        },
        error => {
          let errorMessage = this.errorHandler.handleError(error);
          this._messageService.addErrorMessage(errorMessage);
          }
      );
    }
 
    this.uploadedFile = null;
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.appendHistory("Tag System");
    if(this.uploadedFile){
      const formDataUpdate = new FormData();
      formDataUpdate.append('file', this.uploadedFile);
      formDataUpdate.append('fileName', this.uploadedFile.name);
      formDataUpdate.append('labId', this.selectedLab._id.toString());
      formDataUpdate.append('excelUploadCreatedAt', new Date().toString());
      formDataUpdate.append('excelUploadCreatedBy', this.puid);
      formDataUpdate.append('tagSystemName', this.masterList.tagSystemName);

      this.masterList.tagExcelFileName = this.uploadedFile.name;
      this.blocked=true;
      this.apgTestingService.saveTagsExcel(formDataUpdate).subscribe(
        resultTagUpdate => {
          if (!resultTagUpdate) {
            return;
          }
          this.displayMasterListDialog = false;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Created Tags!', detail: 'Tags in the Excel File are Created.' });
          this.masterList.tagPlates = resultTagUpdate.data;
          this._masterDataService.updateTagSystem(this.masterList).subscribe(
            results => {
              if (!results) {
                return;
              }
              masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
              this.masterLists = masterLists;
              this.displayMasterListDialog = false;
              this.masterList = null;
              this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Tag System!', detail: 'Tag System is Updated.' });
            },
            error => {
               this.handleError(error);
              }
          );
          this.blocked=false
        },
        error => {
          this.handleError(error);
          }
      );
    } else {
      this.blocked=true;
      this._masterDataService.updateTagSystem(this.masterList).subscribe(
        results => {
          if (!results) {
            return;
          }
          masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
          this.masterLists = masterLists;
          this.masterList = null;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Tag System!', detail: 'Tag System is Updated.' });
          this.displayMasterListDialog = false;
          this.blocked=false
        },
        error => {
          this.handleError(error);
          }
      );
    }
    
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  ontagPlatesUpload(event , fileUploader: any){
    if(event.files[0].name.split('.').pop() !== "xlsx"){
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only .xlsx files are allowed.',
      });
      return;
    }
    this.uploadedFile = event.files[0];
    this.uploadedFileName = this.uploadedFile.name;
    fileUploader.clear();
  }

    //if a tagSystemName is existing ,the editing for that fiels is disabled
    isTagSystemName(fieldName) {
      if (this.masterList._id == null || this.masterList._id == '' ||  this.masterList._id == undefined) {
        return false;
      } else if (fieldName == "tagSystemName") {
        return true;
      }
  }

  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }
}
